import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { TableHeader } from 'components/table/table-content';
import { Filters } from 'elements/Filter';
import { PubSub } from 'lib/event/PubSub';
import { FilterManager } from 'lib/tables/FilterManager';
import { AsyncErrorHandler } from 'lib/ui';
import { PenBridleConfigDto } from 'models/pen/PenBridleConfig';
import { PenBridleConfigService } from 'services/pen/pen-bridle-config-service';

@autoinject
export class PenBridleConfigList {
  protected tableData: Array<PenBridleConfigDto>;
  protected activeTableRow: number;

  protected tableHeaders: TableHeader<PenBridleConfigDto>[] = [
    { key: 'Name', label: 'general.name', sortable: true },
    { key: 'MooringConnections', label: 'pens.mooringConnections', sortable: true },
    { key: 'Bridles', label: 'mooring.bridle_plural', sortable: true },
  ];

  constructor(
    private eventAggregator: EventAggregator,
    protected fm: FilterManager,
    private pubsub: PubSub,
    private penBridleConfigService: PenBridleConfigService
  ) {
    pubsub.sub('filter-manager:filter-changed', () => {
      this.updateView();
    });
  }

  protected async attached() {
    this.eventAggregator.subscribe('penBridleConfigReset', () => {
      this.activeTableRow = null;
      return this.updateView();
    });

    this.fm.init({
      context: 'pen-bridle-config-list',
      storageKey: 'pen-bridle-config-list',
      filters: {
        //TODO
      } satisfies Filters,
      defaultFilters: {
        //TOD
      },
    });

    this.updateView();
  }

  @AsyncErrorHandler
  async updateView() {
    const response = await this.penBridleConfigService.getPenBridleConfigs(this.fm.queryFilter);

    if (!response) return;
    this.fm.paginationTotalRecords = +response.headers.get('x-total-count') || 0;

    this.tableData = response.data;
  }

  protected setOrderByColumn(column: string) {
    this.fm.setOrderByColumn(column);
  }

  protected detached() {
    this.pubsub.unsub();
  }

  protected unbind() {
    this.pubsub.unsub();
  }
}
